import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { Configuration } from '../types';

/**
 * Get a secret through the Portainer API rather than the Kubernetes proxy. The
 * response carries the secret's data only for users holding K8sSecretsDetailsR, so
 * this is the only read path available to users who cannot see secret values.
 */
export async function getSecret(
  environmentId: EnvironmentId,
  namespace: string,
  secret: string
) {
  try {
    const { data } = await axios.get<Configuration>(
      `/kubernetes/${environmentId}/namespaces/${namespace}/secrets/${secret}`
    );
    return data;
  } catch (e) {
    // use parseAxiosError instead of parseKubernetesAxiosError
    // because this is an internal portainer api endpoint, not through the kube proxy
    throw parseAxiosError(e, 'Unable to retrieve secret');
  }
}
